import { render, staticRenderFns } from "./InputCodeTrader.vue?vue&type=template&id=88ba7576&"
import script from "./InputCodeTrader.vue?vue&type=script&lang=ts&"
export * from "./InputCodeTrader.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports